// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"7609d75b","208":"a6c25e8f","209":"d80f623c","717":"6374386a","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};